import { createPortal } from "react-dom";

function ReturnPolicy({ onClose }) {
  return createPortal(
    <div style={overlayStyle}>
      <div style={boxStyle}>

        {/* Header */}
        <div style={headerStyle}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <span style={{ fontSize: "28px" }}>📦</span>
            <div>
              <h4 style={{ margin: 0, fontSize: "20px", fontWeight: "700", color: "#111" }}>
                Return Policy
              </h4>
              <p style={{ margin: 0, fontSize: "12px", color: "#777" }}>
                Shopeindia — Effective Date: January 1, 2026
              </p>
            </div>
          </div>
          <button onClick={onClose} style={closeBtnStyle}>✕</button>
        </div>

        {/* Content */}
        <div style={contentStyle}>

          <p style={paraStyle}>
            At <b>Shopeindia</b>, we want you to be fully satisfied with your purchase. If you are not happy with a product, our Return Policy provides a clear and fair process. Please read the following carefully before initiating a return.
          </p>

          <Section title="1. Return Window">
            <ul style={listStyle}>
              <li>Returns must be requested within <b>7 days</b> of the delivery date</li>
              <li>After 7 days, return requests will not be accepted</li>
              <li>The return window starts from the date of delivery as confirmed by the courier tracking system</li>
            </ul>
          </Section>

          <Section title="2. Eligible Return Conditions">
            <p style={paraStyle}>A return will be accepted <b>only</b> if the product:</p>
            <ul style={listStyle}>
              <li>Is <b>unused, unwashed, and unassembled</b> in its original condition</li>
              <li>Has all <b>original packaging, tags, labels, and accessories</b> intact</li>
              <li>Was received in a <b>damaged or defective</b> state</li>
              <li>Was delivered as a <b>wrong item</b> (different from what was ordered)</li>
              <li>Has a <b>manufacturing defect</b> that was not caused by misuse</li>
            </ul>
          </Section>

          <Section title="3. Non-Returnable Items">
            <p style={paraStyle}>The following items are <b>strictly non-returnable</b>:</p>
            <ul style={listStyle}>
              <li><b>Single-use / disposable items</b> — lancets, needles, blades, gloves</li>
              <li><b>Opened hygiene products</b> — any item whose seal has been broken</li>
              <li><b>Digital products</b> — e-books, online courses, once accessed</li>
              <li>Items that are <b>damaged by the customer</b> through misuse or improper handling</li>
              <li>Products marked as <b>"Non-Returnable"</b> on the product listing page</li>
              <li>Customized or personalized products</li>
            </ul>
          </Section>

          <Section title="4. How to Initiate a Return">
            <p style={paraStyle}>Follow these steps to raise a return request:</p>
            <ul style={listStyle}>
              <li><b>Step 1:</b> Contact us within 7 days of delivery via email at <b>support@shopeindia.co.in</b> or call <b>+91 7385743121</b></li>
              <li><b>Step 2:</b> Provide your <b>Order ID</b>, reason for return, and clear <b>photos or video</b> of the product and its packaging</li>
              <li><b>Step 3:</b> Our team will review and respond within <b>2–3 business days</b></li>
              <li><b>Step 4:</b> If approved, you will receive a <b>Return Authorization</b> with shipping instructions</li>
              <li><b>Step 5:</b> Pack the product securely and ship it to the address provided</li>
            </ul>
          </Section>

          <Section title="5. Return Shipping">
            <ul style={listStyle}>
              <li>If the return is due to <b>our error</b> (wrong or damaged item): return shipping is <b>FREE</b> — we will arrange pickup or reimburse shipping cost</li>
              <li>If the return is due to <b>customer preference</b> or change of mind: customer bears the return shipping charges</li>
              <li>Please use a <b>trackable shipping service</b> when sending returns</li>
              <li>Shopeindia is not responsible for items lost or damaged during return transit</li>
            </ul>
          </Section>

          <Section title="6. Inspection & Approval">
            <ul style={listStyle}>
              <li>Once the returned product is received, it will be inspected within <b>2–3 business days</b></li>
              <li>If the return is approved, a <b>refund or replacement</b> will be initiated</li>
              <li>If the product is found to be used, damaged by customer, or not in original condition, the return will be <b>rejected</b> and the product may be sent back to the customer</li>
            </ul>
          </Section>

          <Section title="7. Replacement Option">
            <p style={paraStyle}>
              If you prefer a <b>replacement</b> instead of a refund, we will ship the correct or new product once the return is received and approved. Replacement is subject to product availability. If the item is out of stock, a full refund will be issued.
            </p>
          </Section>

          <Section title="8. Exchange Policy">
            <p style={paraStyle}>
              Direct exchange of products for a different size, color, or model is currently <b>not available</b>. Please return the item and place a fresh order for the product you wish to purchase.
            </p>
          </Section>

          <Section title="9. Contact Us">
            <p style={paraStyle}><b>Shopeindia</b></p>
            <p style={paraStyle}><b>Address:</b> Shopeindia, Warud, Maharashtra, India</p>
            <p style={paraStyle}><b>Phone:</b>+91 7385743121</p>
            <p style={paraStyle}><b>Email:</b> support@shopeindia.co.in</p>
            <p style={paraStyle}><b>Timings:</b> Monday to Saturday, 10:00 AM – 6:00 PM IST</p>
          </Section>

        </div>

        {/* Footer */}
        <div style={actionsStyle}>
          <button onClick={onClose} style={acceptBtnStyle}>
            ✓ I Understand
          </button>
          <button onClick={onClose} style={cancelBtnStyle}>
            Close
          </button>
        </div>

      </div>
    </div>,
    document.body
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: "18px" }}>
      <h5 style={{ fontSize: "14px", fontWeight: "700", color: "#24aeb1", marginBottom: "8px", borderBottom: "1px solid #e8f8f8", paddingBottom: "4px" }}>
        {title}
      </h5>
      {children}
    </div>
  );
}

const overlayStyle = { position: "fixed", inset: 0, background: "rgba(0,0,0,0.65)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 99999, padding: "16px" };
const boxStyle = { background: "#fff", width: "100%", maxWidth: "720px", borderRadius: "16px", display: "flex", flexDirection: "column", maxHeight: "90vh", boxShadow: "0 20px 60px rgba(0,0,0,0.3)", overflow: "hidden" };
const headerStyle = { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "18px 24px", borderBottom: "2px solid #e8f8f8", background: "#f7fffe", flexShrink: 0 };
const closeBtnStyle = { background: "#f1f5f9", border: "none", width: "32px", height: "32px", borderRadius: "50%", fontSize: "16px", cursor: "pointer", color: "#475569" };
const contentStyle = { overflowY: "auto", padding: "20px 24px", flex: 1, fontSize: "13.5px", color: "#444", lineHeight: "1.7" };
const paraStyle = { marginBottom: "8px" };
const listStyle = { paddingLeft: "20px", marginBottom: "8px", display: "flex", flexDirection: "column", gap: "4px" };
const actionsStyle = { display: "flex", gap: "10px", justifyContent: "flex-end", padding: "14px 24px", borderTop: "1px solid #eee", flexShrink: 0 };
const acceptBtnStyle = { background: "#24aeb1", color: "#fff", border: "none", padding: "10px 24px", borderRadius: "8px", fontWeight: "600", fontSize: "14px", cursor: "pointer" };
const cancelBtnStyle = { background: "#f1f5f9", color: "#333", border: "none", padding: "10px 20px", borderRadius: "8px", fontWeight: "500", fontSize: "14px", cursor: "pointer" };

export default ReturnPolicy;